import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController, LoadingController } from 'ionic-angular';
//import { Questions } from '../../models/questions';
import { Answer } from '../../models/answer';
import { Option } from '../../models/option';
import { Items } from '../../providers/providers';
import * as moment from 'moment';
import { Subject } from 'rxjs';
// import { HomePage } from '../../pages/pages';

enum questionType {
  questionDefaultType = 1,
  questionLikertType = 2,
  questionMultiType = 3,
  questionScaleType = 4,
  questionTextType = 5,
  questionTestType = 6
}

/**
 * Generated class for the TestQuestionsPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage({
  name: 'test-questions',
  segment: 'assessment',
})
@Component({
  selector: 'page-test-questions',
  templateUrl: 'test-questions.html',
})
export class TestQuestionsPage {

  clientId: string;
  is_parent_2: string;
  questions: any;
  questionsArray = [];
  requiredQuestionsArray = [];
  answersArray: Answer[];
  answer: Answer;
  assessmentId: string;
  exampleShowed: boolean;
  currentTest: string;
  currentResponse: string;
  completedResponseId: string;
  currentAssesmentId: string;
  testStartTime: number;
  testEndTime: number;
  lastResponseTime: string;
  testsArray = [];
  totalPages: string;
  currentPage: string;
  questionsPerPage: string;
  answer_text: string;
  answer_text_id: number;
  callback: any;
  options: Option[];
  assessmentName: string;
  instructions: string;
  answerType: string;
  uniqueId: string;
  isScheduledAssessment: boolean;
  textQuestion: string;
  questionType: typeof questionType = questionType;
  clientName: string;
  assessments = [];
  index: number;
  selectedValues = [];
  isEmailResultToClient: string = this.navParams.get('isEmailResultToClient')
  reportsArray: Array<{ report_url: string, assessmentName: string }> = [];
  subject = new Subject(); //a traditional event bus to both emit values and register subscribers.
  isenabled: boolean;

  page = {
    index: 0,
    size: '0',
    pagination: '1',
    count: 1
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public items: Items, public toastCtrl: ToastController, public loading: LoadingController) {
    this.isenabled = true;
    this.questions = null;
    this.questions = this.navParams.get('data');
    // this.callback = this.navParams.get('callback');
    this.testStartTime = performance.now();
    this.clientId = this.navParams.get('clientId');
    this.is_parent_2 = this.navParams.get('is_parent_2');
    this.uniqueId = this.navParams.get('uuId');
    this.clientName = this.navParams.get('clientName');
    this.assessments = this.navParams.get('assessmentsArray');
    this.index = this.navParams.get('index');
    this.reportsArray = this.navParams.get('reports')
    //this.answer =  new Answer();
    console.log(this.is_parent_2)
  }

  ionViewDidLoad() {
    // to restrict browser refresh on this page. The other option is to get the values from provider if refresh needs to be allowed
    if (this.questions == undefined) {
      localStorage.clear();
      this.navCtrl.setRoot('login');
    } else {
      this.questionsArray = this.questions.questions;
      this.assessmentName = this.questions.short_name;
      this.instructions = this.questions.instructions;
      this.answerType = this.questions.answer_type_id;
      this.page.size = this.questions.number_of_questions;
      this.page.pagination = this.questions.questions_per_page;
      this.assessmentId = this.questions.id;
      this.answersArray = new Array<Answer>();
      for (let i = 0; i < this.questionsArray.length; i++) {
        let requiredQuestion: any;
        requiredQuestion = this.questionsArray[i];
        if (requiredQuestion.answer_type_id === '4' || requiredQuestion.answer_type_id === '5' || requiredQuestion.answer_type_id === '8') {
          this.answer = new Answer();
          this.answer.question_number = i + 1;
          this.answer.answer_text = "";
          this.answersArray.push(this.answer);//for each question create an answer with question id and blank answer
        }
        else {
          if (requiredQuestion.answer_type_id === '7') {
            this.answer = new Answer();
            this.answer.question_number = i + 1;
            this.answer.answer_text = []; //02/10/2021
            this.answersArray.push(this.answer);
          } else {
            this.answer = new Answer();
            this.answer.question_number = i + 1;
            this.answer.answer_value = ""; //don't need to send the value if question is optional 19/05/2019
            this.answersArray.push(this.answer);
            //this.answersArray.push(new Answer(i+1, ""));//for each question create an answer with question id and blank answer  
          }
        }
        if (requiredQuestion.optional == 0) {
          this.requiredQuestionsArray.push(parseInt(requiredQuestion.number));
        }
      }
      if (this.uniqueId != undefined) {
        this.isScheduledAssessment = true;
      }
    }
  }
  //not required anymore but will leave it here if any event needs to be captured
  // sendData(event: any): void {
  //   this.callback(this.questions).then(() => { this.navCtrl.pop() });
  // }

  onSubmit() {
    var indices = [];
    var message = '';
    var i = 0;
    for (let data of this.answersArray) {    
      // ideally add as answer model property to get quesiton details, dont want to change that for now  
      var question = this.questionsArray[data.question_number - 1];
      if (question.answer_type_id == 8) {
        if (data.answer_text != '') {
          //even if field is optional, still validate email if input is not empty
          var checkEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
          if (!data.answer_text.match(checkEmail)) {
            message = 'Question ' + data.question_number + ' need to be valid email';
          }
        } else {
          // if (question.optional == 0) {
          //   indices.push(data.question_number);
          // }
        }
      }

      if ((this.requiredQuestionsArray.indexOf(data.question_number) >= 0)) {
        if (data.answer_value === '' || data.answer_text === '') {
          indices.push(data.question_number);
        }
      }
      i++;
    }
    if (indices.length > 0) {
      this.presentAlert(indices.join())
    } else if (indices.length == 0 && message != '') {
      // show required error first
      this.messageAlert(message)
    }
    else {
      this.answersArray = this.answersArray.filter(answer => answer.answer_value != "");
      this.testEndTime = performance.now();
      if (this.uniqueId != undefined) {
        this.isScheduledAssessment = true;
        this.isenabled = false;
        this.items.submitScheduledAssessment(this.answersArray,
          {
            time_taken: (this.testEndTime - this.testStartTime) / 1000.0,
            assessment_id: this.assessmentId,
            local_time: moment().format(),
            schedule: this.uniqueId
          })
          .subscribe(
            data => {//add the report url from the url to the array
              if (data) {
                this.reportsArray.push({ report_url: data.url, assessmentName: this.assessmentName });
                this.subject.next(this.reportsArray);//Subject is used to emit values to its subscribers
              }
            }, (err) => {
              console.log(err);

          });

      } else {
        //call the api here
    console.log(this.is_parent_2)
        this.items.submitAssessment(this.answersArray, this.clientId,
          {
            time_taken: (this.testEndTime - this.testStartTime) / 1000.0,
            assessment_id: this.assessmentId,
            local_time: moment().format(),
            //local_time: new Date().toISOString(),
            client_id: this.clientId,
            is_parent_2: this.is_parent_2
          })
          .subscribe((resp) => {
          }, (err) => {
            console.log(err);

          });
      }
      //check if more assessments are there in the array
      if (this.index + 1 < this.assessments.length) {
        this.index = this.index + 1;
        if (this.uniqueId != undefined) {// it's a scheduled assessment
          this.isenabled = false;
          this.subject.subscribe(
            data => {
              this.navCtrl.push('administer', { assessments: this.assessments, uId: this.uniqueId, isSchedule: true, index: this.index, isEmailResultToClient: this.isEmailResultToClient, reports: data })
           })
        } else {// it's an administered assessment
          this.navCtrl.push('administer', { clientName: this.clientName, assessments: this.assessments, clientId: this.clientId, is_parent_2: this.is_parent_2, index: this.index })
        }

      } else {
        if (this.uniqueId != undefined) {// it's a scheduled assessment
          this.isenabled = false;
          this.subject.subscribe(
            data => {
              this.navCtrl.push('assessment-complete', { assessmentCompleted: true, isSchedule: this.isScheduledAssessment, clientId: this.clientId, isEmailResultToClient: this.isEmailResultToClient, reports: data });
           })
        } else {
          this.navCtrl.push('assessment-complete', { assessmentCompleted: true, isSchedule: this.isScheduledAssessment, clientId: this.clientId, s_parent_2: this.is_parent_2, isEmailResultToClient: this.isEmailResultToClient, reports: this.reportsArray });
        }

      }
      
      // this.callback(this.answersArray).then(() => {
        // this.navCtrl.setRoot('administer',{clientName: this.clientName, assessments: this.assessments, clientId: this.clientId, index:this.index});
        // this.navCtrl.popToRoot();
        //after the getData method in administer.ts returns resolved then the navCtrl closes the page
        // this.navCtrl.pop();
      // });

    }
  }

  presentAlert(ques: string) {
    let alert = this.alertCtrl.create({
      title: 'Unanswered questions',
      subTitle: 'please answer question(s) ' + ques,
      buttons: ['Ok']
    });
    alert.present();
  }

  messageAlert(message: string) {
    let alert = this.alertCtrl.create({
      title: 'Invalid Answer',
      subTitle: message,
      buttons: ['Ok']
    });
    alert.present();
  }

  onSelect(question: any, option: string, questionIndex: any) {
    if (question.answer_type_id === '1' || question.answer_type_id === '2') {
      this.answersArray[questionIndex].question_number = parseInt(question.number);
      this.answersArray[questionIndex].answer_value = option.toString();//ng-model binding
    }

  }

  onMultiSelect(answer: any, question: any, option: string, questionIndex: any, selected: any) {
    if (question.answer_type_id === '7') {
      let currentSelected = this.answersArray[questionIndex].answer_text;

      if (selected) {
        currentSelected.push(answer);
      } else {
          const index = currentSelected.indexOf(answer, 0);
          if (index > -1) {
            currentSelected.splice(index, 1);
          }
      }
      this.answersArray[questionIndex].question_number = parseInt(question.number);
      this.answersArray[questionIndex].answer_text = currentSelected;//ng-model binding
    }

  }

  onChange(question: any, questionValue: any, questionIndex: any) {
    this.answersArray[questionIndex].question_number = parseInt(question.number);
    this.answersArray[questionIndex].answer_text = questionValue.toString();//ng-model binding

  }

  onInput(question: any, questionIndex: any) {
    if (question.answer_type_id === '4' || question.answer_type_id === '8') {
      this.answersArray[questionIndex].question_number = parseInt(question.number);
      this.answersArray[questionIndex].answer_text = question.value;//this.textQuestion;//ng-model binding
    }
  }

  onRangeSelect(question: any, questionValue: any, questionIndex: any){
    this.answersArray[questionIndex].question_number = parseInt(question.number);
    this.answersArray[questionIndex].answer_value = questionValue.value.toString();
  }

  getAnswerLabel(label: string) {
    var answerLabels = [];
    answerLabels = label.split('|', 40);//changed the value from 11 to 40 https://freedcamp.com/NovoPsych_vls/Webapp_1IP/todos/32218554/
    return answerLabels;
  }

  getRangeAnswerLabel(label: any, index: any) {
    var answerLabels = [];
    answerLabels = label.split('|', 2);
    if(index === 0){
      return answerLabels[0];
    }else if(index === 1){
      return answerLabels[1];
    }
    return answerLabels;
  }

  getScoring(label: any, value: any) {
    var answerLabels = [];
    answerLabels = label.split('|', 2);
    if(value === 0){
      return answerLabels[0];
    }else if(value === 1){
      return answerLabels[1];
    }
    return answerLabels;
  }

  goBack() {
    let prompt = this.alertCtrl.create({
      title: 'Enter Password',
      message: "Please enter the password to exit assessment",
      inputs: [
        {
          name: 'password',
          placeholder: 'password',
          type: 'password'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'Exit',
          handler: data => {
            if (data.password === localStorage.getItem('password')) {
              this.navCtrl.push('home');
            } else {
              let toast = this.toastCtrl.create({
                message: 'The password is incorrect',
                duration: 3000,
                position: 'top'
              });
              toast.present();
            }

          }
        }
      ]
    });
    prompt.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/test-questions/test-questions.ts